var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"arrow-position",style:(_vm.styleCSS),attrs:{"src":"/img/icons/common/back-arrow.svg"},on:{"click":function($event){return _vm.pushRoute()}}})}
var staticRenderFns = []

export { render, staticRenderFns }